module.exports = __webpack_public_path__ + "static/media/stretch-tile.13781ecc.png";